export default "__VITE_ASSET__BhObsZkH__"